export const API_BASE = `https://api.izilifepay.com`;

export const BACKEND_URL = `${API_BASE}/api`;

export const SERVICE_CLIENT_URL = `https://api-ops.kafintechgroup.com`;
export const CMS_KAFINTECH_URL = `https://api-ops.kafintechgroup.com`;

export const SERVICE_CLIENT_API_API = `${SERVICE_CLIENT_URL}/api`;

export const CMS_KAFINTECH_API_URL = `${CMS_KAFINTECH_URL}/api`;
